const select = {
  select:'Seleccione',
  placeholder:'Seleccione un artículo',
  sort_by: 'Ordenar por',
  favorite: 'Favorito',
  title: 'Título',
  developer: 'Desarrollador',
  mostPromoted: 'Más promocionado',
  ipAddress: 'Dirección IP',
  appPackage: 'Paquete de software',
  selectAppId: 'ID de la aplicación',
  developerName: 'Nombre del desarrollador',
  paypalEmail: 'Correo electrónico de PayPal',
  paypalEmailFraud: 'Correo electrónico de PayPal (Fraude)',
  emailService: 'Servicio de correo electrónico',
  developerEmail: 'Correo electrónico del desarrollador',
  cpiAppPackage: 'Paquete de software de CPI',
  userEmail: 'Correo electrónico del usuario',
  keyword: 'Palabra clave',
};
export default select;
